import { ReturnStatusKey, ClaimStatusKey } from '../../../../typings/returns';

const useGetReturnsStatusKeyName = (status: ReturnStatusKey | ClaimStatusKey, isInfo = false) =>
  isInfo
    ? `dlv_returns_status_info_${status.toLowerCase()}`
    : `dlv_returns_status_${status.toLowerCase()}`;

export default useGetReturnsStatusKeyName;
